import React from 'react'

import { useOverlayState } from '../firebase/hooks/useOverlays'
import CornerTagOverlayComponentChyronStyle from '../sharedLegacy/components/CornerTagOverlayComponent/CornerTagOverlayComponentChyronStyle'
import { ChyronType } from '../firebase/model/chyron-model'

import {
  SpeakerChyron,
  SpeakerInfoChyron,
  QuestionChyron,
  NextUpChyron,
  PollResultChyron,
  SpeakersOverviewChyron,
  WebinarInfoChyron,
  J2SIntroChyron,
} from './chyrons'

import './chyron-overlay.scss'

const ChyronOverlay = () => {
  const overlay = useOverlayState()

  if (!overlay) return null

  return (
    <div className="chyron-overlay">
      {(() => {
        switch (overlay.type) {
          case ChyronType.Speaker: {
            const { name, title, avatarUrl } = overlay
            return (
              <SpeakerChyron name={name} title={title} avatarUrl={avatarUrl} />
            )
          }
          case ChyronType.SpeakerInfo: {
            const { name, title, avatarUrl, bio, company } = overlay
            return (
              <SpeakerInfoChyron
                name={name}
                title={title}
                avatarUrl={avatarUrl}
                bio={bio}
                company={company}
              />
            )
          }
          case ChyronType.SpeakersOverview: {
            const { speakers } = overlay
            return <SpeakersOverviewChyron speakers={speakers} />
          }
          case ChyronType.Question: {
            const { name, question, title, avatarUrl } = overlay
            return (
              <QuestionChyron
                question={question}
                name={name}
                title={title}
                avatarUrl={avatarUrl}
              />
            )
          }
          case ChyronType.NextUp: {
            const { name, title } = overlay
            return <NextUpChyron name={name} title={title} />
          }
          case ChyronType.ComingUp:
          case ChyronType.CornerTag: {
            const { text } = overlay
            return <CornerTagOverlayComponentChyronStyle text={text} />
          }
          case ChyronType.PollResult: {
            const { question, options } = overlay
            return <PollResultChyron question={question} options={options} />
          }
          case ChyronType.WebinarInfo: {
            const { title, date, thumbnail } = overlay
            return (
              <WebinarInfoChyron
                title={title}
                date={date}
                thumbnail={thumbnail}
              />
            )
          }
          case ChyronType.J2SIntroduction: {
            return <J2SIntroChyron />
          }
          default: {
            return null
          }
        }
      })()}
    </div>
  )
}

export { ChyronOverlay }
